

export default {
  SET_ITEMS(state, payload) {
    state.artisans = payload
  },

  SET_ITEMS_WITH_INTERVENTIONS(state, payload) {
    state.artisans_with_interventions = payload
  },

  SET_ITEMS_FULL_NAME(state, payload) {
    state.fullNameArtisans = payload
  },

  ADD_ITEM(state, payload) {
    state.artisans.push(payload)
  },

  UPDATE_ITEM(state, payload) {
      const ItemIndex = state.artisans.findIndex((p) => p.id == payload.id)
      Object.assign(state.artisans[ItemIndex], payload)
  },

  REMOVE_ITEM(state, itemId) {
      const ItemIndex = state.artisans.findIndex((p) => p.id == itemId)
      state.artisans.splice(ItemIndex, 1)
  }
}
